import { Routes, Route } from 'react-router-dom';
import PrivateRoute from '../utils/PrivateRoute';
import FormAfterSignUpPage from '../pages/FormAfterSignUpPage';
import HomePage from '../pages/HomePage';
import Page404 from '../pages/Page404';
import BusinessPage from '../pages/BusinessPage';
import DashboardPage from '../pages/DashboardPage';
import GetStartedPage from '../pages/GetStartedPage';
import LoanPage from '../pages/LoanPage';
import PaymentPage from '../pages/PaymentPage';
import SignupPage from '../pages/SignupPage';
import SignupPrivateRoute from '../utils/SignupPrivateRoute';
import DefaultLayout from '../layouts/DefaultLayout';
import LoanHistory from '../pages/LoanHistory';
import LoanBusiness from '../pages/LoanBusiness';
import ForgotPasswordPage from '../pages/ForgotPasswordPage';
import CreateNewPasswordPage from '../pages/CreateNewPasswordPage';
import NewPasswordProtectedRoute from '../utils/NewPasswordProtectedRoute';
import SecurityQuestionPage from '../pages/SecurityQuestionPage';
import BusinessRegistration from '../pages/BusinessRegistration';
import Balance from '../pages/Balance';
import Setting from '../pages/Setting';
import Store from '../pages/Store';
import PaymentTransactions from '../pages/PaymentTransactions';
import PaymentSettlements from '../pages/PaymentSettlements';
import PaymentCustomers from '../pages/PaymentCustomers';
import PaymentDisputes from '../pages/PaymentDisputes';
import PaymentBank from '../pages/PaymentBank';
import EditSettings from '../pages/EditSetting';
import SettingSecurity from '../pages/SettingSecurity';
import SettingBusinessInformation from '../pages/SettingBusinessInformation';
import SettingPaymentPage from '../pages/SettingPaymentPage';
import EntrepreneurStatusPage from '../pages/PaymentStatusPages/EntrepreneurStatusPage';
import settingIcon from '../assets/icons/setting.svg';
import TandC from '../features/authentication/signup/TandC';
import ComingSoon from '../pages/ComingSoon';
import FlutterwavPaymentCompleted from '../pages/PaymentStatusPages/FlutterwavPaymentCompleted';
// import LimitedLiablityRegistration from '../features/limiletdLiability/LimitedLiablityRegistration';
import PrivacyPolicy from '../pages/PrivacyPolicy';
import LimitedLiablityNew from '../pages/LimitedLiabilityNew';
import IncorporatedTrustees from '../pages/IncorporatedTrustees';
import PostIncorporationService from '../pages/PostIncorporationService';
import OtpPage from '../pages/OtpPage';
import LoggedInUserSecurity from '../pages/LoggedInUserSecurity';

export default function AppRouter() {
  return (
    <Routes>
      <Route path='/' element={<HomePage />} />
      <Route path='/forgot-password' element={<ForgotPasswordPage />} />
      <Route path='/signup' element={<SignupPage />} />
      <Route path='*' element={<Page404 />} />
      <Route path='/set-security-questions' element={<SecurityQuestionPage />} />
      <Route path='/verify-otp' element={<OtpPage />} />
      <Route path='/registration/entrepreneur/payment' element={<EntrepreneurStatusPage />} />
      <Route path='/flutterwave-payment-completed' element={<FlutterwavPaymentCompleted />} />
      <Route path='/terms-of-service' element={<TandC />} />
      <Route path='/privacy-policy' element={<PrivacyPolicy />} />
      <Route path='/coming-soon' element={<ComingSoon />} />

      {/* <Route
        path='/business'
        element={
          <DefaultLayout>
            <BusinessPage />
          </DefaultLayout>
        }
      /> */}
      {/* Protect the new password route to only work for urls with valide token and email */}
      <Route element={<NewPasswordProtectedRoute />}>
        <Route path='/new-password' element={<CreateNewPasswordPage />} />
      </Route>
      {/* Protected Routes. All private routes and dashboard routes requiring authorization go in here */}
      <Route element={<PrivateRoute />}>
        {/* Dashboard routes */}
        <Route path='/Postincorportationservice' element={<PostIncorporationService />} />
        <Route
          path='/dashboard'
          element={
            <DefaultLayout>
              <GetStartedPage />
            </DefaultLayout>
          }
        />
        <Route
          path='/my-dashboard'
          element={
            <DefaultLayout>
              <DashboardPage />
            </DefaultLayout>
          }
        />

        <Route
          path='/my-business'
          element={
            <DefaultLayout>
              <BusinessPage />
            </DefaultLayout>
          }
        />
        <Route
          path='/my-business/business-registration'
          element={
            <DefaultLayout>
              <BusinessRegistration />
            </DefaultLayout>
          }
        />
        <Route
          path='/my-business/limited-liability'
          element={
            <DefaultLayout ltd>
              <LimitedLiablityNew />
            </DefaultLayout>
          }
        />
        <Route
          path='/my-business/incorporated-trustee'
          element={
            <DefaultLayout>
              <IncorporatedTrustees />
            </DefaultLayout>
          }
        />
        {/* Payment routes */}
        <Route
          path='/payment/payment-link'
          element={
            <DefaultLayout>
              <PaymentPage />
            </DefaultLayout>
          }
        />
        <Route
          path='/payment/transactions'
          element={
            <DefaultLayout>
              <PaymentTransactions />
            </DefaultLayout>
          }
        />
        <Route
          path='/payment/settlements'
          element={
            <DefaultLayout>
              <PaymentSettlements />
            </DefaultLayout>
          }
        />
        <Route
          path='/payment/customers'
          element={
            <DefaultLayout>
              <PaymentCustomers />
            </DefaultLayout>
          }
        />
        <Route
          path='/payment/disputes'
          element={
            <DefaultLayout>
              <PaymentDisputes />
            </DefaultLayout>
          }
        />
        <Route
          path='/payment/bank-account'
          element={
            <DefaultLayout>
              <PaymentBank />
            </DefaultLayout>
          }
        />

        {/* Store Route */}
        <Route
          path='/store/transactions'
          element={
            <DefaultLayout>
              <Store />
            </DefaultLayout>
          }
        />

        {/* Balance */}
        <Route
          path='/balance/account'
          element={
            <DefaultLayout>
              <Balance />
            </DefaultLayout>
          }
        />

        {/* Settings */}
        <Route
          path='/settings/profile-information'
          element={
            <DefaultLayout icon={settingIcon} title='Settings'>
              <Setting />
            </DefaultLayout>
          }
        />
        <Route
          path='/settings/security'
          element={
            <DefaultLayout icon={settingIcon} title='Settings'>
              <SettingSecurity />
            </DefaultLayout>
          }
        />
        <Route
          path='/settings/business-information'
          element={
            <DefaultLayout icon={settingIcon} title='Settings'>
              <SettingBusinessInformation />
            </DefaultLayout>
          }
        />
        <Route
          path='/settings/reset-security-questions'
          element={
            <DefaultLayout icon={settingIcon} title='Settings'>
              <LoggedInUserSecurity />
            </DefaultLayout>
          }
        />
        <Route
          path='/settings/payment-services'
          element={
            <DefaultLayout icon={settingIcon} title='Settings'>
              <SettingPaymentPage />
            </DefaultLayout>
          }
        />
        <Route
          path='/settings/profile-information/edit'
          element={
            <DefaultLayout icon={settingIcon} title='Settings'>
              <EditSettings />
            </DefaultLayout>
          }
        />

        {/* Loan route */}
        <Route
          path='/loan/loan-application'
          element={
            <DefaultLayout>
              <LoanPage />
            </DefaultLayout>
          }
        />
        <Route
          path='/loan/loan-history'
          element={
            <DefaultLayout>
              <LoanHistory />
            </DefaultLayout>
          }
        />
        <Route
          path='/loan/loan-business'
          element={
            <DefaultLayout>
              <LoanBusiness />
            </DefaultLayout>
          }
        />
      </Route>

      <Route element={<SignupPrivateRoute />}>
        {/* Added about business route. The form after user signs up */}
        <Route path='/about/business' element={<FormAfterSignUpPage />} />
      </Route>
    </Routes>
  );
}
